import { Reveal, Overline } from "@/components/Reveal";
import { CTAButton } from "@/components/CTAButton";
import TestimonialsGrid from "@/components/TestimonialsGrid";
import GoogleReviews from "@/components/GoogleReviews";

export default function Testimonials() {
  return (
    <div>
      <section className="container-x pt-36 md:pt-44 pb-16 md:pb-20">
        <Overline className="mb-6">Client Testimonials</Overline>
        <h1 className="font-display text-5xl md:text-7xl lg:text-[6rem] font-extrabold leading-[0.9] tracking-tighter uppercase max-w-4xl">The Work<br />Speaks.</h1>
        <p className="mt-8 text-lg md:text-xl font-light text-taupe max-w-2xl leading-relaxed">Homeowners, designers and builders across Perth on what it's like to work with CEMTEX.</p>
      </section>

      <section className="container-x pb-20">
        <TestimonialsGrid />
      </section>

      <section className="bg-offwhite py-24 md:py-32" data-testid="testimonials-google">
        <div className="container-x grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <Overline className="mb-6">Verified Reviews</Overline>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold leading-tight mb-6">Rated 5.0 across Google.</h2>
            <p className="text-taupe font-light leading-relaxed max-w-md">Our reputation is built one flawless surface at a time. Read what Perth clients are saying — and add your own once we've completed your project.</p>
          </div>
          <GoogleReviews />
        </div>
      </section>

      <section className="bg-charcoal text-white py-24 md:py-32 text-center" data-testid="testimonials-cta">
        <div className="container-x">
          <h2 className="font-display text-4xl md:text-6xl font-extrabold mb-10">Become our next story.</h2>
          <CTAButton to="/contact" testid="testimonials-cta-button" variant="accent">Get a Free Quote</CTAButton>
        </div>
      </section>
    </div>
  );
}
